import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { $features } from 'app/effector/features'

import { Typo } from 'components/_old/Typo/Typo'

import { Typography } from 'components/atoms/Typography'

import { getRiskWarningText, type GetRiskWarningTextProps } from './model/riskWarning'

const AttentionModalText = memo<Omit<GetRiskWarningTextProps, 'recommendedPreset' | 'desiredPreset'>>(
  ({ presets, recommendedPresetIndex, desiredPresetIndex, postText, preText }) => {
    const features = useUnit($features)
    const isNewQuestionnaire = features.get('new-questionnaire')
    const result = getRiskWarningText({
      presets,
      recommendedPresetIndex,
      desiredPresetIndex,
      isNewQuestionnaire,
      postText,
      preText,
    })

    return (
      <Typography size={14} align="left">
        <Typo multiline>{result}</Typo>
      </Typography>
    )
  },
  (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps),
)
AttentionModalText.displayName = 'AttentionModalText'

export { AttentionModalText }
